import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks.
 * Use this whenever rendering user-provided or external HTML content.
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
  });
}

/**
 * Sanitizes SVG content to prevent XSS attacks.
 * Allows SVG-specific elements while removing dangerous content like scripts.
 */
export function sanitizeSvg(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { svg: true, svgFilters: true },
  });
}

/**
 * Creates a sanitized dangerouslySetInnerHTML object for HTML content.
 * Usage: <div {...sanitizedHtml(content)} />
 */
export function sanitizedHtml(dirty: string): {
  dangerouslySetInnerHTML: { __html: string };
} {
  return {
    dangerouslySetInnerHTML: { __html: sanitizeHtml(dirty) },
  };
}

/**
 * Creates a sanitized dangerouslySetInnerHTML object for SVG content.
 * Usage: <svg {...sanitizedSvg(content)} />
 */
export function sanitizedSvg(dirty: string): {
  dangerouslySetInnerHTML: { __html: string };
} {
  return {
    dangerouslySetInnerHTML: { __html: sanitizeSvg(dirty) },
  };
}
